import * as yup from 'yup';

yup.setLocale({
	string: {
		min: ({ min }) => `Minimum number of characters - ${min}`,
		max: ({ max }) => `Maximum number of characters - ${max}`,
		matches: () => 'Field can only contain latin letters'
	}
});
